import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Upload, Download } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { toast } from "sonner";

export function ImportExport({ onImported }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const doImport = async (text) => {
    try {
      const parsed = JSON.parse(text);
      setBusy(true);
      const t = await apiFetch("/themes/import", {
        method: "POST",
        body: JSON.stringify({ theme: parsed }),
      });
      toast.success(`Imported “${t.name}”`);
      onImported?.(t);
    } catch (e) {
      toast.error(e.message || "That doesn’t look like a valid Nirvana theme file.");
    } finally {
      setBusy(false);
    }
  };

  const onFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => doImport(String(reader.result));
    reader.readAsText(file);
    e.target.value = "";
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="import-export">
      <input ref={fileRef} type="file" accept="application/json,.json" className="hidden" onChange={onFile} data-testid="import-file-input" />
      <Button variant="outline" className="gap-1.5" disabled={busy} onClick={() => fileRef.current?.click()} data-testid="import-theme-btn">
        <Upload className="h-4 w-4" /> Import theme
      </Button>
    </div>
  );
}

export async function exportTheme(themeId, themeName) {
  try {
    const cfg = await apiFetch(`/themes/${themeId}/export`);
    const blob = new Blob([JSON.stringify(cfg, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(themeName || "nirvana-theme").toLowerCase().replace(/[^a-z0-9]+/g, "-")}.json`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Theme exported");
  } catch (e) {
    toast.error(e.message || "Could not export theme.");
  }
}
